// extracted by mini-css-extract-plugin
export var downArrow = "_78-0";
export var label = "_78-1";
export var treatmentCard = "_78-3";
export var upArrow = "_78-2";